import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const editPhonecentersSysModel = ( {data, phonecentersSysModelId} : {data: IPostEditPhonecentersSysModel | {}, phonecentersSysModelId: number}): Promise<string> => {
  return axiosDefaultApi.put(`/api/PhonecentersSysModels/UpdatePhonecentersSysModel/${phonecentersSysModelId}`, data);
};

type QueryFnType = typeof editPhonecentersSysModel;

type UseEditPhonecentersSysModelOptions = {
  data: IPostEditPhonecentersSysModel | {};
  phonecentersSysModelId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useEditPhonecentersSysModel = ({ config }: UseEditPhonecentersSysModelOptions) => { 
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην επεξεργασία του Μοντέλου.`, 500);
            console.error('Couldnt edit PhonecentersSysModel', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllPhonecentersSysModels"])
            addNotification('Το Μοντέλο Ενημερώθηκε.', 200);
            setIsNotificationVisible(true)
          },
        ...config,
        mutationFn: editPhonecentersSysModel,
    })
}